import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import User_ProfileView from "../../../../user/User_ProfileView.tsx";

export const Route = createFileRoute('/_app/profiles/$player_uid/dashboard')({
    component: RouteComponent,
})

function RouteComponent() {
    return <User_ProfileView subpage={'dashboard'} />
}
